import { Expose, Type } from "class-transformer";
import { CertificationValuationAccountingCategoryEnum } from "@altertec_gparn/lib";
import { AccountingAccountDto } from "@/core/features/accounting-accounts/accounting-account.dto";

export class CertificationValuationAccountingConfigurationDto {
  @Expose()
  category: CertificationValuationAccountingCategoryEnum;

  @Expose()
  label: string;

  @Expose()
  accountingAccountId?: string | null;

  @Expose()
  @Type(() => AccountingAccountDto)
  accountingAccount?: AccountingAccountDto | null;
}
